import { render, staticRenderFns } from "./veSbzcZcRevert.vue?vue&type=template&id=48ac2b80&scoped=true"
import script from "./veSbzcZcRevert.vue?vue&type=script&lang=js"
export * from "./veSbzcZcRevert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac2b80",
  null
  
)

export default component.exports